export class User {
    public contact: number;
    public level: number;
    public email: string;
    public lastname: string;
    public firstname: string;
    public phone: string;
    public lang: string;
    public plainPassword: string;
    public active: boolean;
    public roles: any[];

    constructor() {

    }

    public setUser(data: any) {
        //   this.contact = data.contact ? data.contact.id : null;
        this.level = data.level.id;
        this.email = data.email;
        this.lastname = data.lastname;
        this.firstname = data.firstname;
        this.phone = data.phone ? data.phone : null;
        this.lang = data.lang;
        this.active = data.active;
        this.plainPassword = data.plainPassword;
        this.roles = data.roles;

    }
}
